// libraries
import React from 'react'
import clsx from 'clsx'

// prop types
interface Props {
    children?: React.ReactNode
    bgColor?: 'primary' | 'secondary' | 'tertiary' | 'tertiary-10' | 'white' | string
    paddingTop?: 'big' | 'medium' | 'small'
    paddingBottom?: 'big' | 'medium' | 'small'
    className?: string
    id?: string
}

export default function Section({
    bgColor,
    paddingTop,
    paddingBottom,
    children,
    className,
    id
}: Props) {

    // custom bg color
    const customBgColor = bgColor && !['primary', 'secondary', 'tertiary', 'tertiary-10', 'white'].includes(bgColor) ? { backgroundColor: bgColor } : {}

    return (
        <section
            id={id}
            className={clsx(
                'section',

                // paddings
                paddingTop === 'big' && 'section--top-big',
                paddingTop === 'medium' && 'section--top-medium',
                paddingTop === 'small' && 'section--top-small',
                paddingBottom === 'big' && 'section--bottom-big',
                paddingBottom === 'medium' && 'section--bottom-medium',
                paddingBottom === 'small' && 'section--bottom-small',

                // bg colors
                bgColor === 'primary' && 'bg-primary',
                bgColor === 'secondary' && 'bg-secondary',
                bgColor === 'tertiary' && 'bg-tertiary',
                bgColor === 'tertiary-10' && 'bg-tertiary-10',
                bgColor === 'white' && 'bg-white',

                className
            )}
            style={customBgColor}
        >
            <div className='relative z2'>
                {children}
            </div>
        </section>
    )
}